import { UpperCasePipe } from '@angular/common';
import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

import { CelumButtonModule } from '@celum/common-components/button';
import { CelumCheckboxItemModule } from '@celum/common-components/checkbox-item';
import { ColorConstants } from '@celum/common-components/constants';
import { CelumIconModule, IconConfiguration } from '@celum/common-components/icon';

@Component({
  selector: 'language-chooser',
  templateUrl: 'language-chooser.component.html',
  styleUrl: 'language-chooser.component.scss',
  encapsulation: ViewEncapsulation.None, // custom style for celum button
  imports: [MatMenuModule, UpperCasePipe, CelumButtonModule, CelumCheckboxItemModule, CelumIconModule]
})
export class LanguageChooserComponent {
  public readonly activeLanguagesChanged = output<{ key: string; checked: boolean }>();
  public activeLanguages = input<Set<string>>();
  public defaultLanguage = input<string>();
  public availableLanguages = input<string[]>();

  protected readonly arrowIcon = IconConfiguration.xSmall('arrow-down-xs').withColor(ColorConstants.BLUE_GRAY_900);

  protected handleClick(e: Event): void {
    // just preventing default menu closing
    e.stopPropagation();
  }

  protected languageWasChecked(checked: boolean, key: string): void {
    this.activeLanguagesChanged.emit({ key, checked });
  }
}
